import { render } from "./VitLeadership.vue?vue&type=template&id=60ce34c3&ts=true"
import script from "./VitLeadership.vue?vue&type=script&lang=ts"
export * from "./VitLeadership.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__